module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter1",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_c('h2', {
    staticClass: "c4"
  }, [_vm._v("PRACTICAL ASTROLOGY, &c.")])]), _vm._v(" "), _c('p', {
    staticClass: "c10"
  }, [_vm._v("By the word Astrology (derived from the Greek "), _c('span', {
    attrs: {
      "xml:lang": "grc"
    }
  }, [_vm._v("αστηρ")]), _vm._v(", "), _c('em', {
    staticClass: "calibre12"
  }, [_vm._v("a star")]), _vm._v(", and "), _c('span', {
    attrs: {
      "xml:lang": "grc"
    }
  }, [_vm._v("λογος")]), _vm._v(", "), _c('em', {
    staticClass: "calibre12"
  }, [_vm._v("a discourse")]), _vm._v(",) is meant\nthe art of prognosticating or foretelling events"), _c('a', {
    attrs: {
      "id": "r8"
    }
  }), _c('span', {
    staticClass: "c12",
    attrs: {
      "href": "#/Text/Section0044#f8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', {
    staticClass: "calibre13"
  }, [_vm._v("[8]")])]), _vm._v(" by\nthe "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Aspects")]), _vm._v(", "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Positions")]), _vm._v(", and "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Influence")]), _vm._v(" of\nthe HEAVENLY BODIES.")]), _vm._v(" "), _c('p', {
    staticClass: "c11"
  }, [_vm._v("By "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Aspect")]), _vm._v(" is to be understood an angle formed\nby the rays of two planets meeting on earth, able\nto execute some natural power or influence; which\nmay be better explained by the following table.")]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre10"
  }, [_c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "c15",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    attrs: {
      "id": "Page_26",
      "title": "26"
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('th', {
    staticClass: "c16",
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "xlarge"
  }, [_vm._v("CHARACTERS OF THE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "bbtd"
  }), _vm._v(" "), _c('td', {
    staticClass: "bbtd"
  }), _vm._v(" "), _c('td', {
    staticClass: "bbtd"
  }), _vm._v(" "), _c('td', {
    staticClass: "bbtd1"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "bbt"
  }, [_c('em', {
    staticClass: "calibre12"
  }, [_vm._v("Six Northern Signs.")])]), _vm._v(" "), _c('td', {
    staticClass: "bbt"
  }, [_c('em', {
    staticClass: "calibre12"
  }, [_vm._v("Six Southern Signs.")])]), _vm._v(" "), _c('td', {
    staticClass: "bbt"
  }, [_c('em', {
    staticClass: "calibre12"
  }, [_vm._v("Planets.")])]), _vm._v(" "), _c('td', {
    staticClass: "bbt1"
  }, [_c('em', {
    staticClass: "calibre12"
  }, [_vm._v("Aspects.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }, [_vm._v("♈︎ Aries.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♎︎ Libra.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♄ Saturn.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  }, [_vm._v("☌ Conjunction.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }, [_vm._v("♉︎ Taurus.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♏︎ Scorpio.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♃ Jupiter.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  }, [_vm._v("⚹ Sextile.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }, [_vm._v("♊︎ Gemini.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♐︎ Sagittarius.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♂ Mars.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  }, [_vm._v("Δ Trine.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }, [_vm._v("♋︎ Cancer.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♑︎ Capricorn.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("☉ Sun.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  }, [_vm._v("☐ Quartile.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }, [_vm._v("♌︎ Leo.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♒︎ Aquarius.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("⦵ Earth.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  }, [_vm._v("☍ Opposition.")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }, [_vm._v("♍︎ Virgo.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♓︎ Pisces.")]), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("♀ Venus.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "brt"
  }), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }), _vm._v(" "), _c('td', {
    staticClass: "brt"
  }, [_vm._v("☿ Mercury.")]), _vm._v(" "), _c('td', {
    staticClass: "c17"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre11"
  }, [_c('td', {
    staticClass: "bbtd"
  }), _vm._v(" "), _c('td', {
    staticClass: "bbtd"
  }), _vm._v(" "), _c('td', {
    staticClass: "bbtd"
  }, [_vm._v("☽ Luna.")]), _vm._v(" "), _c('td', {
    staticClass: "bbtd1"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "c11"
  }, [_vm._v("This art, or rather this conjectural science, is\nprincipally divided into "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Natural")]), _vm._v(" and "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Judiciary")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5aaef08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0007.vue
// module id = 75
// module chunks = 0